var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "#fff",
    stroke: "#00B070"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65 12.812a1.023 1.023 0 0 0 .002 1.396l3.026 3.234a2 2 0 0 0 2.92.002l7.739-8.248a1.026 1.026 0 0 0-1.496-1.404l-6.245 6.653a2 2 0 0 1-2.918 0l-1.533-1.636a1.023 1.023 0 0 0-1.495.003Z",
    fill: "#00B070",
    stroke: "#00B070"
  })));
};
export default SvgSuccess;